/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type MaintainSigneeOrderInput = {
    isMaintainSigneeOrder: boolean;
    documentId: string;
    clientMutationId?: string | null;
};
export type maintainSigneeOrderMutationVariables = {
    input: MaintainSigneeOrderInput;
};
export type maintainSigneeOrderMutationResponse = {
    readonly maintainSigneeOrder: {
        readonly success: boolean | null;
    } | null;
};
export type maintainSigneeOrderMutation = {
    readonly response: maintainSigneeOrderMutationResponse;
    readonly variables: maintainSigneeOrderMutationVariables;
};



/*
mutation maintainSigneeOrderMutation(
  $input: MaintainSigneeOrderInput!
) {
  maintainSigneeOrder(input: $input) {
    success
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MaintainSigneeOrderPayload",
    "kind": "LinkedField",
    "name": "maintainSigneeOrder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "maintainSigneeOrderMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "maintainSigneeOrderMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b39ec1c633027f66cfaa744ae72852c6",
    "id": null,
    "metadata": {},
    "name": "maintainSigneeOrderMutation",
    "operationKind": "mutation",
    "text": "mutation maintainSigneeOrderMutation(\n  $input: MaintainSigneeOrderInput!\n) {\n  maintainSigneeOrder(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
(node as any).hash = '2d48e242a3a32c1252a2a5874c61f1c2';
export default node;
